import { render, staticRenderFns } from "./SystemHistory.vue?vue&type=template&id=585b3b27&"
import script from "./SystemHistory.vue?vue&type=script&lang=js&"
export * from "./SystemHistory.vue?vue&type=script&lang=js&"
import style0 from "./SystemHistory.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports